import { useEffect, useState } from "react";

/* Chart.js core */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

/* Components */
import Sidebar from "./components/Sidebar_temp";
import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import Analytics from "./components/Analytics";
import Employees from "./components/Employees";
import Table from "./components/Table";
import Settings from "./components/Settings";

/* Register ChartJS once */
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const API_BASE = "https://admin-dashboard-node-js.onrender.com";

export default function App() {
  const [active, setActive] = useState("dashboard");
  const [status, setStatus] = useState("Checking server...");
  const [online, setOnline] = useState(false);
  const [data, setData] = useState(null);

  /* Load server status + data */
  useEffect(() => {
    async function init() {
      try {
        // Health check
        const healthRes = await fetch(`${API_BASE}/health`);
        const healthJson = await healthRes.json();

        if (!healthJson.ok) {
          throw new Error("Server offline");
        }

        setStatus("✅ Server Online");
        setOnline(true);

        // Load dashboard data
        const dataRes = await fetch(`${API_BASE}/data/all`);
        const dataJson = await dataRes.json();
        setData(dataJson);

      } catch (err) {
        console.error(err);
        setStatus("❌ Cannot connect");
        setOnline(false);
      }
    }

    init();
  }, []);

  if (!data) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  return (
    <div className="app">
      {/* Sidebar */}
      <Sidebar active={active} setActive={setActive} />

      {/* Main */}
      <div className="main">
        <Header status={status} online={online} />

        <div className="content">
          {active === "dashboard" && <Dashboard data={data} />}
          {active === "analytics" && <Analytics data={data} />}
          {active === "users" && <Table title="Users" rows={data.users} />}
          {active === "devices" && <Table title="Devices" rows={data.devices} />}
          {active === "employees" && <Employees data={data} />}
          {active === "settings" && <Settings />}
        </div>
      </div>
    </div>
  );
}
